import styled from "styled-components";
import "@fontsource/montserrat"; 

export const FooterWrapper = styled.div`
    background: #282c34;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    z-index: 1;
    width: 100%;
    font-size: 1.0rem;
    font-weight: 500;
    
    @media screen and (max-width: 768px) { 
        flex-direction: column;   
        height: auto;               
        padding-bottom: 20px;            
        font-size: 0.85rem;
        gap: 8px;     
    }
`;

export const FooterItem = styled.div`
    padding: 0 8px;
    font-family: "montserrat";
    @media screen and (max-width: 768px) { 
        padding: 4px 0;
    }
`;

export const FooterSocials = styled.div`
  display: flex;
  gap: 12px; /* space between icons */
  align-items: center;
  justify-content: center;
`;